import React, { useState } from "react"

import LoginForm from "components/pages/login/login"
import RegisterForm from "components/pages/login/register"

import { Button } from "components/anti"
import { useRouter } from "next/router"

import logo from "assets/img/karafuru/logo/logo-2.png"

const CheckoutLogin = () => {
  const [currentTab, setCurrentTab] = useState("register")
  const Router = useRouter()

  const handleSuccess = () => (window.location.href = "/checkout")

  const LoginComponent = <LoginForm activeTab={currentTab} fn={handleSuccess} />

  const RegisterComponent = (
    <RegisterForm
      setCurrentTab={setCurrentTab}
      activeTab={currentTab}
      fn={handleSuccess}
    />
  )

  return (
    <section className="sc-login-wrapper">
      <div className="container mw-md">
        <div className="px-sm-down-0 login-box">
          <div className="header-login text-center">
            <img
              src={logo}
              alt="profile"
              className="logo-dark img-fluid"
              onClick={() => Router.push("/")}
            />
          </div>
          <div className="form-nav row row-0">
            <div className="col-6">
              <Button
                variant="login"
                className={`btn-block ${currentTab === "register" ? "active" : ""
                  }`}
                onClick={() => setCurrentTab("register")}
              >
                Register
              </Button>
            </div>
            <div className="col-6">
              <Button
                variant="login"
                className={`btn-block ${currentTab === "login" ? "active" : ""
                  }`}
                onClick={() => setCurrentTab("login")}
              >
                Login
              </Button>
            </div>
          </div>
          {LoginComponent}
          {RegisterComponent}
        </div>
      </div>
    </section>
  )
}

export default CheckoutLogin
